var render = function render(){var _vm=this,_c=_vm._self._c;return _c('a',{staticClass:"whatsapp-suporte",attrs:{"href":_vm.link,"target":"_blank","rel":"noopener noreferrer","title":"Falar com o suporte no WhatsApp","aria-label":"Falar com o suporte no WhatsApp"}},[_c('v-icon',{attrs:{"color":"#fff","large":""}},[_vm._v("mdi-whatsapp")])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }